import React from 'react';
import { LinearProgress, Stack, Typography, Box } from '@mui/material';
import ReportSection from './ReportSection';
import EmptyState from './EmptyState';
import { formatMoney, formatNumber, toNumber } from '../utils/formatters';

const OrderServiceMonthlyEvolution = ({ data = [] }) => {
    const maxAmount = Math.max(...data.map((item) => toNumber(item.total_amount)), 0);

    return (
        <ReportSection
            title="Evolución mensual"
            subtitle="Volumen y monto generado por mes"
        >
            {data.length === 0 ? (
                <EmptyState />
            ) : (
                <Stack spacing={1.5}>
                    {data.map((item) => {
                        const progress = maxAmount > 0
                            ? Math.round((toNumber(item.total_amount) / maxAmount) * 100)
                            : 0;

                        return (
                            <Box key={item.period}>
                                <Stack direction="row" justifyContent="space-between">
                                    <Typography variant="body2" fontWeight={800}>
                                        {item.period}
                                    </Typography>

                                    <Typography variant="body2">
                                        {formatNumber(item.total_orders)} OS · {formatMoney(item.total_amount)}
                                    </Typography>
                                </Stack>

                                <LinearProgress
                                    variant="determinate"
                                    value={progress}
                                    sx={{ height: 8, borderRadius: 99, mt: 0.7 }}
                                />
                            </Box>
                        );
                    })}
                </Stack>
            )}
        </ReportSection>
    );
};

export default OrderServiceMonthlyEvolution;